import { gql } from '@apollo/client';

export const ADD_SHUTTLE_SERVICE_PROVIDER = gql`
  mutation AddShuttleServiceProvider($provider: ShuttleServiceProviderInput!) {
    addShuttleServiceProvider(provider: $provider) {
      code
      success
      message
    }
  }
`;

export const UPDATE_SHUTTLE_SERVICE_PROVIDER = gql`
  mutation UpdateShuttleServiceProvider($provider: UpdateShuttleServiceProviderInput!) {
    updateShuttleServiceProvider(provider: $provider) {
      code
      success
      message
    }
  }
`;

export const ADD_SHUTTLE_SERVICE_TO_ROUTE = gql`
  mutation AddShuttleServiceToRoute($shuttleDetails: ShuttleToRouteInput!) {
    addShuttleServiceToRoute(shuttle_details: $shuttleDetails) {
      code
      success
      message
    }
  }
`;

export const ENABLE_DISABLE_SHUTTLE_SERVICE_PROVIDER = gql`
  mutation EnableDisableShuttleServiceProvider($provider_id: NonEmptyString!, $isactive: Boolean!) {
    enableDisableShuttleServiceProvider(provider_id: $provider_id, isactive: $isactive) {
      code
      success
      message
    }
  }
`;